import {
  AggregateRequest,
  AggregateResponse,
  DashboardConfigResponse,
  DashboardWidget,
} from "../types/dashboard/DashboardConfig";
import { getApi, putApi, postApi } from "./helpers/apiMethods";

export const getDashboardConfig = async (
  customerId: string
): Promise<DashboardConfigResponse | undefined> => {
  const response = await getApi<DashboardConfigResponse>(
    `/v1/customers/${customerId}/dashboard-config`
  );
  return response.data;
};

export const saveDashboardConfig = async (
  customerId: string,
  widgets: DashboardWidget[]
): Promise<void> => {
  await putApi(`/v1/customers/${customerId}/dashboard-config`, { widgets });
};

export const aggregateDashboardData = async (
  customerId: string,
  request: AggregateRequest
): Promise<AggregateResponse | undefined> => {
  const response = await postApi<AggregateResponse>(
    `/v1/customers/${customerId}/dashboard/aggregate`,
    request
  );
  return response.data;
};
